import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'antd';
import ComponentWrapper from './ComponentWrapper';
import { datePickerMap } from './componentMappers';

export default class DateField extends Component {
  static propTypes = {
    showTime: PropTypes.bool,
  };

  static defaultProps = {
    showTime: false,
  };

  render() {
    return (
      <ComponentWrapper
        {...this.props}
        mapProps={datePickerMap(this.props.showTime)}
        render={(props) => {
          // Extract onBlur/onFocus so they are only triggered via onOpenChange
          // (when the picker truly opens/closes), not via native input focus events.
          // Without this, clicking the calendar panel blurs the input, causing
          // react-final-form to mark the field as inactive while still picking a date.
          const { onBlur, onFocus, ...restProps } = props;
          return (
            <DatePicker
              {...restProps}
              onOpenChange={(status) => {
                status ? onFocus() : onBlur();
              }}
            />
          );
        }}
      />
    );
  }
}
